import React, { useState } from 'react';
import { API_BASE_URL } from '../../store/constans';
import { donwloadFileThunk } from '../../store/slices/donwloadFile.slice';
import { useDispatch } from 'react-redux';
import ItinerariesModal from '../modals/itinerariesModal';

const ItinerariesCards = ({ itineraryState }) => {

    const dispatch = useDispatch();
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleDownload = (filename) => {
        dispatch(donwloadFileThunk(filename))
    };

    function getFileNameFromPath(path) {
        return path.split('/').pop();
    }

    const handleOpenModal = () => {
        setShowModal(!showModal);
    }

    return (
        <>
            <div
                className="relative p-3 h-[500px]  flex flex-col justify-end rounded-md shadow-md shadow-gray-500 overflow-hidden"
            >
                <img
                    src={`${API_BASE_URL}${itineraryState.itinerary_yacht?.image}`}
                    alt={itineraryState.itinerary_yacht?.image}
                    loading="lazy"
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${imageLoaded ? "opacity-100" : "opacity-0"}`}
                    onLoad={() => setImageLoaded(true)}
                />
                <div className="relative z-10 h-[195px] bg-black/70 p-3 flex flex-col justify-start gap-3 text-white">
                    <div className="flex gap-3 text-[13px] items-center">
                        <span className="bg-[#2e6a82] py-[2px] px-1 font-semibold uppercase">
                            {itineraryState.itinerary_yacht?.route}
                        </span>
                        <p className="font-semibold">{itineraryState.itinerary_yacht?.routeOption}</p>
                    </div>
                    <h3 className="py-[2px] px-1 font-semibold text-start">{itineraryState.itinerary_yacht?.name}</h3>
                    <div className="text-[14px] font-sans text-start">
                        <p>
                            Departures on <span className="text-[#f29100]">{itineraryState.itinerary_yacht?.departure}</span>
                        </p>
                        <p>
                            Returns on <span className="text-[#f29100]">{itineraryState.itinerary_yacht?.return}</span>
                        </p>
                    </div>
                    <div>
                        <button
                            onClick={() => handleOpenModal()}
                            className="cursor-pointer border shadow-sm shadow-gray-400 hover:scale-110 duration-300 text-[15px] py-1 px-3 font-bold rounded-full text-white ">
                            View More
                        </button>
                    </div>

                </div>

            </div>
            <ItinerariesModal
                isOpen={showModal}
                onClose={handleOpenModal}
                state={itineraryState.itinerary_yacht}
                donwload={() => handleDownload(getFileNameFromPath(itineraryState.itinerary_yacht.file))}
            />
        </>
    );
};

export default ItinerariesCards;